import { PartnershipTransactionFilter } from "@axl-dev/school-sdk";
import { Drawer } from "antd";
import { FC, useCallback } from "react";

import { useDrawer, useSdk } from "@app/shared/lib/hooks";
import { Loc } from "@app/shared/ui";
import Request from "@app/shared/ui/Request";

import { PartnershipTotalCard } from "../../../PartnershipTotalCard/PartnershipTotalCard";
import { TransactionRequestTable } from "../../../RequestTable/TransactionRequestTable";

export const TransactionTotals: FC = () => {
  const requestDrawer = useDrawer();
  const sdk = useSdk();

  const fetchTotals = useCallback(async () => {
    // eslint-disable-next-line no-return-await
    return await sdk.partnership.transactionStore.fetchTotals(
      new PartnershipTransactionFilter(),
    );
  }, []);

  return (
    <>
      <Request action={fetchTotals} auto>
        {({ data, state }) => (
          <div className="flex flex-wrap gap-20">
            {data?.items.map((total) => (
              <PartnershipTotalCard
                key={total.type}
                value={total.value}
                valueType={total.valueType}
                label={
                  <Loc
                    word={`Partnership.member.${total.type}`}
                    default={total.type}
                  />
                }
                onClick={
                  total.type === "requestedAmount"
                    ? requestDrawer.open
                    : undefined
                }
              />
            ))}
            {state !== "success" &&
              [0, 1, 2, 3].map((x) => (
                <PartnershipTotalCard key={x} label="-" />
              ))}
          </div>
        )}
      </Request>

      <Drawer
        title={<Loc word="Partnership.requests" default="Requests" />}
        width={900}
        onClose={requestDrawer.close}
        open={requestDrawer.visible}
        className="p-0"
      >
        <TransactionRequestTable />
      </Drawer>
    </>
  );
};
